<div class="kp-card" *ngIf="assessment" [ngSwitch]="mode">
  <object-renderer [object]="assessment"></object-renderer>
  <div class="d-flex">
    <ng-content select="[toolbar]"></ng-content>
    <ng-container *ngSwitchCase="'list'">
      <a class="btn btn-link" [routerLink]="['/assessment', assessment.TestId]">جزییات</a>
    </ng-container>
    <ng-container *ngSwitchCase="'detail'">
      <button type="button" *ngIf="!assessment.IsPaid" (click)="pay()">خرید</button>
      <button type="button" (click)="saveResult()">ذخیره نتیجه</button>
    </ng-container>
  </div>
</div>